var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.23 0.832H9.655V0.66C9.655 0.1 9.193 0 8.629 0H5.692C5.128 0 4.67 0.1 4.67 0.66V0.832H1.109C1.02899 0.831868 0.949738 0.847531 0.875791 0.878089C0.801844 0.908648 0.734656 0.953501 0.678079 1.01008C0.621502 1.06666 0.576648 1.13384 0.54609 1.20779C0.515531 1.28174 0.499869 1.36099 0.500001 1.441V2.617C0.500001 2.77852 0.564163 2.93342 0.678373 3.04763C0.792582 3.16184 0.947484 3.226 1.109 3.226H13.23C13.3915 3.226 13.5464 3.16184 13.6606 3.04763C13.7748 2.93342 13.839 2.77852 13.839 2.617V1.441C13.839 1.27948 13.7748 1.12458 13.6606 1.01037C13.5464 0.896162 13.3915 0.832 13.23 0.832Z",
    fill: "#DC5D5E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9519 4.84375H2.38686C2.30087 4.84451 2.21602 4.86343 2.13787 4.89929C2.05971 4.93514 1.99002 4.98712 1.93336 5.0518C1.87671 5.11648 1.83436 5.19241 1.80912 5.27461C1.78387 5.35681 1.77628 5.44342 1.78686 5.52875L2.76786 12.9508C2.80445 13.2393 2.94457 13.5047 3.16217 13.6976C3.37977 13.8906 3.66004 13.9979 3.95086 13.9998H10.3879C10.6795 13.9992 10.961 13.8923 11.1797 13.6993C11.3983 13.5062 11.5392 13.2401 11.5759 12.9508L12.5559 5.52875C12.5666 5.44305 12.5591 5.35605 12.5336 5.2735C12.5082 5.19095 12.4655 5.11476 12.4084 5.04998C12.3513 4.98519 12.281 4.9333 12.2023 4.89775C12.1236 4.86219 12.0382 4.84378 11.9519 4.84375Z",
    fill: "#DC5D5E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.b6e161005484a3b095728f1a2aeac725.svg";
export { ForwardRef as ReactComponent };